/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { AccountingAccountDto, AccountingAccountFilterDto } from './accounting-account.dto';

export const AccountingAccountMapper = entity<AccountingAccountDto>({});

export const AccountingAccountFilterMapper = entity<AccountingAccountFilterDto>({});
